import React, {useState} from 'react';
import Toggle from 'react-toggle'
import '../assets/css/reacttoggle.css'

// eslint-disable-next-line
const Toggler = ({onChange, initial})=>{
    const [enable, setEnable] = useState(initial);

    const changer = ()=>{
        setEnable(!enable)
        onChange(!enable);
    }

    return (
    <label>
    <Toggle
        checked={enable}
        icons={false}
        onChange={changer} />
</label>

)}

export default Toggler;